import { NgClass } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { SessionStorageService, TableSelectedItem } from '@core';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'app-table-search-input',
  templateUrl: './table-search-input.component.html',
  standalone: true,
  imports: [
    MatPrefix,
    MatSuffix,
    MatIconButton,
    FormsModule,
    MatFormField,
    MatInput,
    NgClass,
    TippyDirective,
    RouterLink,
  ],
})
export class TableSearchInputComponent implements AfterContentInit {
  @ViewChild('input', { read: TippyDirective }) tippyButton!: TippyDirective;
  @Input() tableId!: string;
  @Input() placeholder = 'Enter Search text';
  @Input() inputValue = '';
  @Input() inputWidth = '256px';
  @Input() cssClass = '';
  @Output() searchDataEvent = new EventEmitter<string>();
  lastPickedItems: TableSelectedItem[] = [];

  constructor(private sessionStorageService: SessionStorageService) { }

  clear() {
    this.inputValue = '';
    this.searchDataEvent.emit('');
  }

  modelChange(value: string) {
    this.searchDataEvent.emit(value.trim());
    value.length ? this.tippyButton.hide() : this.tippyButton.show();
  }

  ngAfterContentInit(): void {
    if (this.tableId) {
      this.lastPickedItems = (this.sessionStorageService.getLastSelectedItems(this.tableId) || []).slice(0, 5);
    }
  }
}
